export default __webpack_public_path__ + "media/987ae186f595b3d862052fc864bea934bbb38544ad1c8c4fb5e292945d05ef9a.svg";